<template>
  <section
    id="pro-vs-pro-plus"
    class="padding-top-5xl"
  >
    <div class="row margin-bottom-4xl">
      <div class="column-12 text-center">
        <h2
          class="text-uppercase size-md with-anchor"
          style="letter-spacing: var(--letter-spacing-3xl); font-weight: var(--font-weight-black); color: var(--fa-dk-yellow)"
        >
          <anchor-link
            anchor="#pro-vs-pro-plus"
            link-color="yellow"
            anchor-name="Today's Specials"
          />
          Today's Specials
        </h2>
        <h1 class="h2 margin-y-md">Go Pro (or Pro+)</h1>
        <p class="line-length-xl margin-auto">
          All plans come with our Classic, Sharp, Duotone, and Sharp Duotone icon packs, including Pro features and services. But you'll need a Pro+ plan to get
          our new Pro+ icon packs. <site-link :to="{ name: 'plans' }">View all our plans</site-link> and get the details about what's included in each.
        </p>
      </div>
    </div>
    <div class="row align-center">
      <div class="column-12 tablet:column-6 laptop:column-4">
        <compare-plan-card
          sku="FA-STANDARD"
          description="A permanent license to FA Pro, access to icon downloads, and a year of services."
          plan-name="Pro"
        />
      </div>
      <div class="column-12 tablet:column-6 laptop:column-4">
        <compare-plan-card
          sku="FA-STANDARD-PLUS"
          all-icon-packs
          plan-color="teal"
          description="Plus plans have everything in our Pro plans, plus extra!"
          plan-name="Pro+"
          plan-tier="plus"
        />
      </div>
      <div class="column-12 tablet:column-6 laptop:column-4">
        <sale-cta />
      </div>
    </div>
  </section>
</template>

<script>
  import SaleCta from '../components/SaleCta'
  import ComparePlanCard from '../components/ComparePlanCard'
  import AnchorLink from '../components/AnchorLink'

  export default {
    name: 'PlanCompare',

    components: {
      SaleCta,
      ComparePlanCard,
      AnchorLink
    },

    props: {
      isSignedIn: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
